import React from 'react';
import FormModal from '../../FormModal.jsx';
import EmployeeForm from './EmployeeForm.jsx';
import { validateEmployee } from '../../../containers/employees/utils/index.js';

function EmployeeFormModal(props) {
  const {
    organizationId,
    createEmployee,
    updateEmployee,
    onGroupSelect,
    onParentSelect,
    onHide,
    resource,
    show,
    onSubmitSuccess,
    selectedEntities,
    isGroupSelectDisabled,
    isInitiative,
    retrieveSuccess,
  } = props;

  const { group, parent } = selectedEntities;

  const createResource = (values) => {
    const employee = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      position: values.position,
      location: values.location,
      externalId: values.externalId,
      groupId: group.length ? group[0].id : null,
      parentId: parent.length ? parent[0].id : null,
    };

    return createEmployee(organizationId, employee);
  };

  const updateResource = (values) => {
    const employee = {
      id: resource.id,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      position: values.position || '',
      location: values.location || '',
      externalId: values.externalId || '',
      groupId: group.length ? group[0].id : null,
      parentId: parent.length ? parent[0].id : null,
    };
    return updateEmployee(employee);
  };

  return (
    <FormModal
      createResource={createResource}
      updateResource={updateResource}
      resource={resource}
      onHide={onHide}
      onSubmitSuccess={(result) => onSubmitSuccess(result)}
      resourceName="Employee"
      show={show}
      getEntities
      validate={validateEmployee}
    >
      {retrieveSuccess ? (
        <EmployeeForm
          onGroupSelect={onGroupSelect}
          onParentSelect={onParentSelect}
          selectedEntities={selectedEntities}
          isGroupSelectDisabled={isGroupSelectDisabled}
          isInitiative={isInitiative}
        />
      ) : (
        <h4>Loading...</h4>
      )}
    </FormModal>
  );
}

export default EmployeeFormModal;
